
import { SVGProps } from 'react';
const SvgChevronDown12 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 12 12"
		{...props}
	>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1}
			d="m3 4.5 3 3 3-3"
		/>
	</svg>
);
export default SvgChevronDown12;
